<template>
  <b-link v-b-modal.privacy-policy-modal>
    Privacy Policy
  </b-link>
</template>

<script>
export default {
  name: 'PrivacyPolicyLink'
}
</script>
